import { PlanType } from 'lib/plans';
import {
  AccessControl,
  Address,
  Feature,
  HomeId,
  InviteToken,
  Member,
} from 'types';
import * as api from 'data/homeHub/api/serverApi';

export type HomeResponse = {
  name: string;
  planType: PlanType;
  maxCapacity: number;
  inviteToken: InviteToken;
  address: Address | null;
  homeId: HomeId;
  members: Array<Member>;
  accessControl: AccessControl;
  features: Array<Feature>;
};

export default process.env.NEXT_PUBLIC_USE_MOCK_API
  ? require('./mockApi')
  : api;
